<template>
  <div v-if="datas && formater">
    <v-sheet v-for="(data, idx) in datas" :key="idx">
      <OnePiecePrint
        :showSinglePrint="showSinglePrint"
        :pageID="idx"
        :formater="formater"
        :data="data"
        :dataFormaterKey="dataFormaterKey"
      />
      <v-divider class="hidden-print" />
    </v-sheet>
  </div>
</template>
<script>
import OnePiecePrint from "@/components/plugins/print/OnePiecePrint";

export default {
  components: {
    OnePiecePrint,
  },

  props: {
    formater: Object,
    datas: Array,
    dataFormaterKey: String,
    showSinglePrint: Boolean,
  },
};
</script>